<i18n src="./resources/locales.json"></i18n>

<template>
  <EcsSideBarWrapper
    class="telephony-side-bar"
    :search-placeholder="$t('placeholder')"
    @search-input-changed="handleSearch"
  >
    <template v-slot:toolbar>
      <div class="px-4">
        <v-btn-toggle v-model="filters" dense class="active-filters">
          <v-btn small active-class="active-filter">
            <v-icon>mdi-phone-incoming</v-icon>
            {{ $t('filters.incoming') }}
          </v-btn>

          <v-btn small active-class="active-filter">
            <v-icon>mdi-phone-outgoing</v-icon>
            {{ $t('filters.outgoing') }}
          </v-btn>

          <!--<v-btn small active-class="active-filter">-->
          <!--<v-icon>mdi-phone-outgoing</v-icon>-->
          <!--out ext-->
          <!--</v-btn>-->
        </v-btn-toggle>
      </div>
    </template>

    <v-row no-gutters class="content">
      <!-- Pending interactions -->
      <EcsSideBarInteractionList
        v-if="displayPendingInteraction"
        :header="$t('header.pendingInteractions')"
        :interactions="getPendingInteractions"
        :max-height="pendingInteractionsContainerHeight"
        is-pending
        show-counter
        hide-load-more
      />

      <!--Active Call Section-->
      <EcsSideBarInteractionList
        v-show="filteredItems.activeInteractions.length"
        :header="$t('header.activeCall')"
        :interactions="filteredItems.activeInteractions"
        :max-height="activeInteractionsContainerHeight"
        show-counter
        hide-load-more
      />

      <!--Call History Section-->
      <EcsSideBarInteractionList
        v-show="filteredItems.historicInteractions.length"
        :header="$t('header.historicalCalls')"
        :interactions="filteredItems.historicInteractions"
        :max-height="historicInteractionsContainerHeight - 28"
      />

      <!-- Empty History Section -->
      <EcsSideBarTileContent v-if="showTileContent" :header="$t('header.historicalCalls')">
        <div class="empty-interaction-history-section pa-2 mx-4">
          <span v-once>
            {{ $t('body.nothing_here') }}
          </span>
          <br />
          <span v-once>
            {{ $t('body.make_history') }}
          </span>
        </div>

        <SideBarLoadMoreBtn v-if="showTileContent" />
      </EcsSideBarTileContent>
    </v-row>
  </EcsSideBarWrapper>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsSideBarInteractionMixins from '@/mixins/ecs-side-bar-interaction-mixins/EcsSideBarInteractionMixins';
import SideBarLoadMoreBtn from '@/components/ecs-app-side-bar/ecs-side-bar-interaction-item/side-bar-load-more-btn/SideBarLoadMoreBtn';

export default {
  name: 'EcsTelephonySideBar',

  components: { SideBarLoadMoreBtn },

  mixins: [EcsSideBarInteractionMixins],

  data() {
    return {
      filters: undefined
    };
  },

  computed: {
    ...mapGetters('INTERACTIONS', ['getActiveTelephonyInteractions', 'getHistoricalTelephonyInteractions']),

    filteredItems() {
      const activeInteractions = this.filterItems(this.getActiveTelephonyInteractions);
      const historicInteractions = this.filterItems(this.getHistoricalTelephonyInteractions);

      if (this.filters !== undefined) {
        let filterFn;

        if (this.filters === 0) {
          filterFn = interaction => interaction.isIncomingTelephony;
        } else {
          filterFn = interaction => interaction.isExternalCall && !interaction.isInternal;
        }

        return {
          activeInteractions: activeInteractions.filter(filterFn),
          historicInteractions: historicInteractions.filter(filterFn)
        };
      }

      return {
        activeInteractions,
        historicInteractions
      };
    },

    showTileContent() {
      return !this.filteredItems.historicInteractions.length;
    }
  },

  methods: {
    getAdditionalSerchableAttributes(item) {
      return `${((item.receptor || {}).phones || []).reduce((accum, phone) => {
        accum += phone.value;
        return accum;
      }, '')} ${((item.receptor || {}).mobiles || []).reduce((accum, phone) => {
        accum += phone.value;
        return accum;
      }, '')}`;
    }
  }
};
</script>

<style scoped lang="scss">
.telephony-side-bar .content {
  height: calc(100vh - 200px);
  display: block;
}
.active-filters {
  background-color: transparent !important;
  width: 100%;
  font-size: 12px;

  .v-btn {
    background-color: transparent;
    flex: 1;
  }

  .v-btn--active::before {
    opacity: 0 !important;
  }

  .active-filter {
    background-color: var(--v-primary-base);
    color: #fff;

    .v-icon {
      color: #fff !important;
    }
  }

  .v-icon {
    font-size: 13px;
    padding-right: 4px;
  }
}
</style>
